export default "__VITE_ASSET__DKoHbmoU__"